import styles from './Badge.module.scss'
import classNames from 'classnames/bind'
const classes = classNames.bind(styles)

export default function Badge({ text, rounded, color = 'primary', dark = false }) {
    return <div className={classes('badge', { rounded, dark }, color)}>{text}</div>
}
